import { Col, Row, Tab , Tabs, Button, Pagination } from 'react-bootstrap';
import { useLocation} from "react-router-dom";
import { useState, useEffect, useCallback } from 'react';

import BasicSpinner from '../common/basic-spinner';
import ListRow from '../common/list-row';

//================================================================

export default function PaginatedList({list, count, type, isPrivate, onClick, onSelect, name, buttonCallback, buttonIcon, buttonRounded}) {

  const [objects, setObjects] = useState(list || []);
  const [isChecked, setIsChecked] = useState(null)
  const [objectsPerPage, setObjectsPerPage] = useState(count || 10);
  const [qtyPages, setQtyPages] = useState(1);
  const [pageIndex, setPageIndex] = useState(0);

  const calulatePagination = () => {
    return Array.from(
      { length : Math.min(qtyPages, 5) },
      (_, index) => {
        if(qtyPages <= 5 || (qtyPages > 5 && pageIndex < 2)){
          return index;
        } else if(qtyPages > 5 && pageIndex >= 2){
          if(pageIndex + 2 >= qtyPages){
            return qtyPages - 5 + index;
          } else {
            return index - 2 + pageIndex;
          }
        } 
      }
    )
  };

  const updateChecked = (checked, id) => {
    if (!objects) return;
    var index = objects.map((e) => { return e._id; }).indexOf(id);
    setIsChecked(isChecked.map((_, i) => i === index ? checked : _))
    onSelect(checked, id);
  }

  useEffect(() => {
    if (onClick) onClick(pageIndex);
  },[pageIndex]);

  useEffect(() => {
    setIsChecked(Array.from({length: objects.length}, () => false));
    setQtyPages(Math.ceil(objects.length / objectsPerPage));
  },[objectsPerPage, objects]);

  useEffect(() => {
    setObjects(list);
  },[list]);

  //----------------------------------------------------------------

  return (
    <>
      {objects.length > 0 &&
        <>
          {objects
            .slice(pageIndex * objectsPerPage, objectsPerPage * (1 + pageIndex))
            .map((object, index) =>
              <ListRow
                key={`listRow-${object._id}`}
                type={type}
                object={object}
                isPrivate={isPrivate || false}
                onSelect={onSelect ? updateChecked : null}
                buttonCallback={buttonCallback}
                buttonIcon={buttonIcon}
                buttonRounded={buttonRounded}
                checked={isChecked ? isChecked[index+pageIndex * objectsPerPage] : false}
              />
            )
          }
          { qtyPages > 1 &&
            <Pagination
              className="my-2 align-objects-center justify-content-center"
            >

              <Pagination.First
                onClick={() => setPageIndex(0)}
                disabled={pageIndex <= 0}
              />

              <Pagination.Prev
                onClick={() => setPageIndex(pageIndex - 1)}
                disabled={pageIndex <= 0}
              />

              {calulatePagination().map(value => 
                <Pagination.Item
                  key={`pagination-${value}`}
                  active={pageIndex === value}
                  onClick={() => setPageIndex(value)}
                >
                  {value + 1}
                </Pagination.Item>
              )}

              <Pagination.Next
                onClick={() => setPageIndex(pageIndex + 1)}
                disabled={pageIndex >= qtyPages - 1}
              />

              <Pagination.Last
                onClick={() => setPageIndex(qtyPages - 1)}
                disabled={pageIndex >= qtyPages - 1}
              />

            </Pagination>
          }
        </>
      }
    </>
  );
}
